import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import ImmutablePureComponent from 'react-immutable-pure-component'
import Layout from './layout'
import { fetchMarketplaceListingAvailableAttributes } from '../actions/marketplace_listing_search'

class MarketplaceLayout extends ImmutablePureComponent {

  componentDidMount() {
    const { availableAttrs, dispatch } = this.props
    if (!availableAttrs) dispatch(fetchMarketplaceListingAvailableAttributes())
  }

  render() {
    const {
      children,
      title,
      tabs,
      noRightSidebar,
      sidebarChildren,
      actions,
      button,
      search,
      layout,
      showBackBtn,
    } = this.props

    return (
      <Layout
        showGlobalFooter
        showNormalSidebar
        showLinkFooterInSidebar
        showBackBtn={showBackBtn}
        page='marketplace'
        tabs={tabs}
        title={title}
        noRightSidebar={noRightSidebar}
        sidebarChildren={sidebarChildren}
        actions={actions}
        button={button}
        search={search}
        layout={layout}
      >
        {children}
      </Layout>
    )
  }

}

const mapStateToProps = (state) => ({
  availableAttrs: state.getIn(['marketplace_listing_search', 'available_attrs']),
})

MarketplaceLayout.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string.isRequired,
  noRightSidebar: PropTypes.bool,
  sidebarChildren: PropTypes.node,
}

export default connect(mapStateToProps)(MarketplaceLayout)
